import Vue from 'vue'
const $t = Vue.prototype.$t
// 表单校验
const baseRule = tip => [{ required: true, message: tip || $t('90') }]
// 多选校验 这里的逻辑是选项必须存在
const customRule = () => [
  {
    validator: (_, value, cFn) => {
      if (!value || !value.length) return cFn(new Error($t('cefb30a7')))
      const state = value.some(item => !item.label)
      if (state) return cFn(new Error($t('c0f620b3')))
      return cFn()
    }
  }
]

// 选项校验
const optionRule = () => [
  {
    validator: (_, value, cFn) => {
      if (!value || !value.length) return cFn(new Error($t('cefb30a7')))
      return cFn()
    }
  }
]
export const rules = {
  name: baseRule(),
  startName: baseRule(),
  endName: baseRule(),
  longName: baseRule(),
  dateType: baseRule($t('221')),
  timeType: baseRule($t('221')),
  options: customRule(),
  fileType: optionRule(),
  maxUploadFiles: baseRule(),
  maxUploadSize: baseRule()
}
